export const application = 'jakapa.website';
